module.exports = __webpack_public_path__ + "static/media/blog-ads-vs-reco-diagram.7ec15c85.png";